import { getCompanyData } from 'store/slices/company';
import { getUserConfig } from 'store/slices/userConfig';
import { getCompanyPlatformsFromCompany } from 'store/slices/companyPlatforms';
import { getWhatsappTemplates } from 'store/slices/templates';
import { getCompanyLabelsList } from 'store/slices/labels';
import { getApplicationUsers } from 'store/slices/applicationUsers';
import { getUnreadChatUsers } from 'store/slices/unread-chat-users';
import { getPriorityDocTypes } from 'store/slices/priority';
import { getMassMessagingGroups, getMassMessagingTasks } from 'store/slices/mass-messaging';
import { getSimpleTemplates } from 'store/slices/simple-templates';
import { store } from 'store';

export const getDataOnLoad = async () => {
  const getCompany = async () => {
    await getCompanyData();
    getCompanyPlatformsFromCompany();

    if (store.getState().company?.CompanyType === 'priority') {
      getPriorityDocTypes();
    }
  };
  getCompany();
  getUserConfig();
  getWhatsappTemplates();
  getSimpleTemplates(); // Load simple templates on app initialization
  getCompanyLabelsList();
  getApplicationUsers();
  getUnreadChatUsers();
  getMassMessagingGroups();
  getMassMessagingTasks();
};
